export var apiPath='/v1/certificates';var actionType='ASSET_AUDITS';export default actionType;